export const tableLabel = [
  {
    label: '需求部门',
    param: 'orgShortName',
    align: 'center',
    minWidth: 140,
  },
  {
    label: '需求申请人',
    param: 'createMemberName',
    align: 'center',
    minWidth: 140,
  },
  {
    label: '物料分类',
    param: 'categoryName',
    align: 'center',
    minWidth: 140,
  },
  {
    label: '物料编码',
    param: 'categoryCustomCode',
    align: 'center',
    minWidth: 140,
  },
  {
    label: '物料描述',
    param: 'categoryDesc',
    align: 'center',
    minWidth: 140,
    tooltip: true
  },
  {
    label: '采购数量',
    param: 'quantity',
    align: 'center',
    minWidth: 140,
  },
  {
    label: '已采数量',
    param: 'readyQuantity',
    align: 'center',
    minWidth: 140,
  },
  {
    label: '采购进度',
    param: 'purchaseDemandTrackStatusDesc',
    align: 'center',
    minWidth: 140,
    slot: 'purchaseDemandTrackStatusDesc',
  },
  {
    label: '期望到货日期',
    param: 'expectedArrivalDate',
    align: 'center',
    minWidth: 180,
  },
  {
    label: '需求计划编号',
    param: 'purchaseDemandCode',
    align: 'center',
    minWidth: 180,
    slot: 'purchaseDemandCode',
  },
  {
    label: '需求计划名称',
    param: 'purchaseDemandName',
    align: 'center',
    minWidth: 140,
  },
  {
    label: '审批状态',
    param: 'purchaseDemandStatusDesc',
    align: 'center',
    minWidth: 140,
  },
  {
    label: '创建日期',
    param: 'createTime',
    align: 'center',
    minWidth: 180,
  },
];

export const fieldList = [
  {
    label: '需求计划名称',
    type: 'input',
    value: 'purchaseDemandName',
  },
  {
    label: '需求计划编号',
    type: 'input',
    value: 'purchaseDemandCode',
  },
  {
    label: '创建日期',
    type: 'date',
    value: 'createTime',
    defaultTime: ['00:00:00', '23:59:59'],
    valueFormat: 'yyyy-MM-dd HH:mm:ss',
    dateType: 'daterange',
  },
  {
    label: '状态',
    type: 'select',
    value: 'purchaseDemandStatus',
    list: 'purchaseDemandStatusList',
  },
];

export const listTypeInfo = {
  purchaseDemandStatusList: [
    { name: '新建', id: 0 },
    { name: '待审核', id: 1 },
    { name: '审核通过', id: 2 },
    { name: '审核驳回', id: 3 },
    { name: '退回', id: 4 },
  ],
};
